/**
 * Global background poller — one 60s setInterval for the entire app.
 * Pages register a key, a tick multiplier, and a callback on mount;
 * unregister on unmount. A registrant with multiplier N fires every N ticks
 * (every N×60 seconds). Skips entirely when the browser tab is backgrounded.
 * The timer starts once via start() in App.vue.
 */
const registry = new Map()   // key → { every: Number, fn: Function }
let tick = 0
let _timer = null

export function start() {
    if (_timer) return
    _timer = setInterval(() => {
        if (document.visibilityState !== 'visible') return
        tick++
        for (const { every, fn } of registry.values()) {
            if (tick % every === 0) fn()
        }
    }, 60_000)
}

export function register(key, every, fn) {
    registry.set(key, { every, fn })
}

export function unregister(key) {
    registry.delete(key)
}
